export interface FilterItem {
  label: string
  fields: string[]
  isNested: boolean
}
export type FilterConfigType = Record<string, FilterItem>

export type FilterReportChipType = {
  dt_venda: FilterItem
  proposta: FilterItem
  cota: FilterItem
  versao: FilterItem
  consorciado: FilterItem
  comissionado: FilterItem
  status: FilterItem
  parcelas: FilterItem
}

export const FILTER_REPORT: FilterReportChipType = {
  dt_venda: {
    label: 'Data de venda',
    fields: ['dt_venda_inicial', 'dt_venda_final'],
    isNested: true
  },
  proposta: {
    label: 'Proposta',
    fields: ['id_documento_inicial', 'id_documento_final'],
    isNested: true
  },
  cota: {
    label: 'Número de cota',
    fields: ['cd_cota_final', 'cd_cota_inicial'],
    isNested: true
  },
  versao: {
    label: 'Número da versão',
    fields: ['versao_inicial', 'versao_final'],
    isNested: true
  },

  consorciado: {
    label: 'Dados do consorciado',
    fields: ['cd_inscricao_nacional'],
    isNested: false
  },
  comissionado: {
    label: 'Dados do comissionado',
    fields: ['cpf_cnpj_comissionado'],
    isNested: false
  },
  status: {
    label: 'Status',
    fields: ['proposal_status'],
    isNested: false
  },
  parcelas: {
    label: 'Parcelas',
    fields: ['proposal_payment'],
    isNested: false
  }
}

export type FilterManagementChipType = {
  dt_venda: FilterItem
  proposta: FilterItem
  grupo: FilterItem
  cota: FilterItem
  versao: FilterItem
  consorciado: FilterItem
  comissionado: FilterItem
}

export const FILTER_MANAGEMENT: FilterManagementChipType = {
  dt_venda: {
    label: 'Data de venda',
    fields: ['dt_venda_inicial', 'dt_venda_final'],
    isNested: true
  },
  proposta: {
    label: 'Proposta',
    fields: ['id_documento'],
    isNested: false
  },
  grupo: {
    label: 'Número de grupo',
    fields: ['cd_grupo'],
    isNested: false
  },
  cota: {
    label: 'Número de cota',
    fields: ['cd_cota'],
    isNested: false
  },
  versao: {
    label: 'Número da versão',
    fields: ['versao'],
    isNested: false
  },
  consorciado: {
    label: 'Dados do consorciado',
    fields: ['cd_inscricao_nacional'],
    isNested: false
  },
  comissionado: {
    label: 'Dados do comissionado',
    fields: ['cd_comissionado', 'cpf_cnpj_comissionado'],
    isNested: false
  }
}

export const FILTER_DOCUMENT_MANAGEMENT: FilterConfigType = {
  dt_venda: {
    label: 'Data de venda',
    fields: ['dt_venda_inicial', 'dt_venda_final'],
    isNested: true
  },
  id_documento: {
    label: 'Proposta',
    fields: ['id_documento_inicial', 'id_documento_final'],
    isNested: true
  },
  consorciado: {
    label: 'Dados do consorciado',
    fields: ['cd_inscricao_nacional'],
    isNested: false
  },
  comissionado: {
    label: 'Dados do comissionado',
    fields: ['cpf_cnpj_comissionado'],
    isNested: false
  },
  st_status: {
    label: 'Status',
    fields: ['st_status'],
    isNested: false
  }
}

interface FilterBensType {
  vl_bem: FilterItem
  parcelas: FilterItem
}

export const FILTER_BENS: FilterBensType = {
  vl_bem: {
    label: 'Valor do bem',
    fields: ['vl_bem_inicial', 'vl_bem_final'],
    isNested: true
  },
  parcelas: {
    label: 'Parcelas',
    fields: ['vl_parcela_inicial', 'vl_parcela_final'],
    isNested: true
  }
}

interface SituationGroupItem {
  label: string
  value: string
}

export const SITUATION_GROUPS: SituationGroupItem[] = [
  {
    label: 'Andamento',
    value: 'A'
  },
  {
    label: 'Formação',
    value: 'F'
  },
  {
    label: 'Todos',
    value: 'T'
  }
]

export const FILTER_FLEX: FilterConfigType = {
  dt_flex: {
    label: 'Período',
    fields: ['dt_flex.dt_inicial', 'dt_flex.dt_final'],
    isNested: true
  },
  st_status: {
    label: 'Tipo',
    fields: ['st_status'],
    isNested: false
  },
  cd_inscricao_nacional: {
    label: 'CPF/CNPJ',
    fields: ['cd_inscricao_nacional'],
    isNested: false
  }
}

export interface IFilterGroupsType {
  tipo_venda: FilterItem
  vl_credito: FilterItem
  pz: FilterItem
  pe_menor_lance: FilterItem
  st_situacao: FilterItem
  id_indexador: FilterItem
}

export const FILTER_GROUPS: IFilterGroupsType = {
  tipo_venda: {
    label: 'Tipo de venda',
    fields: ['tipo_venda'],
    isNested: false
  },
  vl_credito: {
    label: 'Valor do Credito',
    fields: ['vl_credito_inicial', 'vl_credito_final'],
    isNested: true
  },
  pz: {
    label: 'Prazo',
    fields: ['pz_inicial', 'pz_final'],
    isNested: true
  },
  pe_menor_lance: {
    label: 'Menor Lance',
    fields: ['pe_menor_lance_inicial', 'pe_menor_lance_final'],
    isNested: true
  },
  st_situacao: {
    label: 'Situação',
    fields: ['st_situacao'],
    isNested: false
  },
  id_indexador: {
    label: 'Indexador',
    fields: ['id_indexador'],
    isNested: false
  }
}
export type FilterGrupoFieldKeysType =
  (typeof FILTER_GROUPS)[keyof typeof FILTER_GROUPS]['fields'][number]

export const FILTER_PUBLICITY: FilterConfigType = {
  dt_campanha: {
    label: 'Período',
    fields: ['dt_campanha.dt_iv_campanha', 'dt_campanha.dt_fv_campanha'],
    isNested: true
  },
  st_status: {
    label: 'Status',
    fields: ['st_status'],
    isNested: false
  },
  nm_campanha: {
    label: 'Nome da campanha',
    fields: ['nm_campanha'],
    isNested: false
  }
}

export const FILTER_USER: FilterConfigType = {
  nm_pessoa: {
    label: 'Nome',
    fields: ['nm_pessoa'],
    isNested: false
  },
  cd_inscricao_nacional: {
    label: 'Documento',
    fields: ['cd_inscricao_nacional'],
    isNested: false
  },
  cd_usuario: {
    label: 'Código do usuário',
    fields: ['cd_usuario'],
    isNested: false
  }
}

export const FILTER_CONFIRMATION: FilterConfigType = {
  cd_inscricao_nacional: {
    label: 'CPF/CNPJ',
    fields: ['cd_inscricao_nacional'],
    isNested: false
  }
}

export const FILTER_LOJA: FilterConfigType = {
  nm_razao_social: {
    label: 'Razão Social',
    fields: ['nm_razao_social'],
    isNested: false
  },
  cd_cnpj: {
    label: 'CNPJ',
    fields: ['cd_cnpj'],
    isNested: false
  },
  st_situacao: {
    label: 'Situação',
    fields: ['st_situacao'],
    isNested: false
  }
}
